module.exports = __webpack_public_path__ + "img/repair-img.747ddd72.png";